module.exports = __webpack_public_path__ + "media/customizations/simplyartavia/back-79c23a2e42d4b3a7de16298b89a9a5cf.jpg";